import * as React from "react";
import { StyleProp, StyleSheet, ViewStyle } from "react-native";
import _ from "lodash";

import { Family } from "../../types";

import { View, Text } from "../../components/Themed";
import commonStyles from "../../styles/common";
import useUpdateFamily from "../../hooks/families/useUpdateFamily";

import FamilyListItem, { FamilyListItemProps } from "./FamilyListItem";

export interface FamilyListProps {
  style?: StyleProp<ViewStyle>;
  families?: Family[];
  renderItem?: (props: FamilyListItemProps) => JSX.Element;
}

function FamilyList({
  style,
  families,
  renderItem: Item = FamilyListItem,
}: FamilyListProps) {
  const { mutate: updateFamily } = useUpdateFamily();
  const empty = !families?.length;

  return (
    <View style={[style, commonStyles.grid]}>
      {families?.map((family) => (
        <React.Fragment key={family.id}>
          <Item
            family={family}
            onSave={(values) => {
              // updateFamily({ ...values, id: family.id });
            }}
          />
        </React.Fragment>
      ))}

      {empty && <Text>No Families</Text>}
    </View>
  );
}

const styles = StyleSheet.create({});

export default FamilyList;
